import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'delivery',
    [ORDER_METHODS.PICKUP]: 'pickup',
    [ORDER_METHODS.ROOM_SERVICE]: 'on site',
  },
  feedback: {
    payment_method_disabled: 'We do not accept {{paymentMethod}} payments for {{orderMethod}} orders',
  },
};
